import React from "react";

const Loader = ({ minHeight }) => {
  const loaderContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: minHeight || "100%",
    position: "relative",
  };

  const loaderStyle = {
    "--hue": "210",
    "--size": "80px",
    "--border": "10px",
    "--speed": "1s",
    "--blur": "10px",
    width: "10px",
    aspectRatio: "1",
    background: "white",
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform:
      "translate(-50%, -50%) rotate(0deg) translateY(calc((100px * -0.5) + (10px * 0.5)))",
    animation: "spin var(--speed) infinite linear",
  };

  const keyframesStyle = `
    .loader::before {
      content: "";
      position: absolute;
      inset: calc(var(--border) * -0.5);
      border-radius: 50%;
      background: white;
      filter: blur(var(--blur));
      z-index: -1;
    }

    .loader::after {
      content: "";
      width: var(--size);
      aspect-ratio: 1;
      position: absolute;
      top: 0%;
      left: 50%;
      translate: -50% 0;
      background: conic-gradient(
        white,
        hsl(var(--hue), 100%, 70%),
        hsl(var(--hue), 100%, 10%),
        transparent 65%
      );
      border-radius: 50%;
      mask: radial-gradient(
        transparent calc(((var(--size) * 0.5) - var(--border)) - 1px),
        white calc((var(--size) * 0.5) - var(--border))
      );
    }

    @keyframes spin {
      from {
        transform: translate(-50%, -50%) rotate(0deg)
        translateY(calc((var(--size) * -0.5) + (var(--border) * 0.5)));
      }
      to {
        transform: translate(-50%, -50%) rotate(-360deg)
        translateY(calc((var(--size) * -0.5) + (var(--border) * 0.5)));
      }
    }
  `;

  return (
    <div style={loaderContainerStyle}>
      <div className="loader" style={loaderStyle}></div>

      <style>{keyframesStyle}</style>
    </div>
  );
};

export default Loader;

